// TODO: Move these into `formFields.ts` ↴

export const MULTI_BOUND = 'multiBound';
export const SINGLE_BOUND = 'singleBound';

export const DESTINATION = 'destination';
export const ORIGIN = 'origin';

export const DEPARTURE_DATE = 'departureDate';
export const DEPARTURE_TIME_OF_DAY = 'departureTimeOfDay';

export const RETURN_DATE = 'returnDate';
export const RETURN_TIME_OF_DAY = 'returnTimeOfDay';

export default {
  DEPARTURE_DATE,
  DEPARTURE_TIME_OF_DAY,
  DESTINATION,
  MULTI_BOUND,
  ORIGIN,
  RETURN_DATE,
  RETURN_TIME_OF_DAY,
  SINGLE_BOUND,
};
